import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { createBrowserHistory } from '@remix-run/router';
import { useLocation, useNavigate } from 'react-router-dom';

import { DealActions } from '../../actions';
import Popup from '../../components/ui/Popup/Popup';
import NewDealPopup from './popups/dealPopups/NewDealPopup';
import { Toast, notify } from '../../components/ui/Toast/Toast';
import { dealsTableConfig } from './configs/dealConfigs/dealsTableConfig';
import DealsDataSection from './components/dealComponents/DealsDataSection';
import { getUserPermissionLevel } from '../../utils/getUserPermissionLevel';

function DealsPage() {
    // States
    const [dealsDataTable, setDealsDataTable] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [newDealPopupView, setNewDealPopupView] = useState(false)
    const [paginationMetadata, setPaginationMetadata] = useState({
        totalItems: 0,
        currentPage: 1,
        pageSize: 30
    });
    const [filterQuery, setFilterQuery] = useState('');

    const userData = useSelector((state) => state.UserReducer.userProfileData);

    const navigate = useNavigate();

    // Hooks
    const location = useLocation();
    const history = createBrowserHistory();

    const fetchDealsData = async (page) => {
        setLoadingTable(true);
        setDealsDataTable([]);

        const result = await DealActions.getAllDeals(userData, `&page_size=${paginationMetadata.pageSize}&display=${userData.userProfileName}${filterQuery}`, page);

        if (result.success) {
            setDealsDataTable(result.data);
            setPaginationMetadata(prevState => ({ ...prevState, currentPage: page }));

            if (paginationMetadata.totalItems !== result.metadata.count) {
                setPaginationMetadata(prevState => ({ ...prevState, totalItems: result.metadata.count }));
            }
        }
        else {
            notify('Erreur de récuperation des affaires');
        }

        setLoadingTable(false);
    }

    useEffect(() => {
        fetchDealsData(1);
    }, [filterQuery])

    // Check navigation message existence
    useEffect(() => {
        if (location.state === 'invalid_id') {
            notify('Affaire inexistante');
        }
        else if (location.state === 'deal_deleted') {
            notify('Affaire supprimée');
        }
        history.replace({ ...history.location, state: null });
    }, []);

    const handleMissionNavigation = async (dealId) => {
        const getDeal = await DealActions.getDealById(userData, dealId);

        if (getDeal.success) {
            const permissionLevel = getUserPermissionLevel(getDeal.data, userData);

            if (permissionLevel.level !== 'producer' && permissionLevel.level !== 'producer_referent') {
                navigate(`/deals/${dealId}`);
            } else {
                navigate(`/deals/${dealId}/missions`);
            }
        }
    }

    const filterDealList = async (query) => {
        setFilterQuery(`&${query}`);
    }

    // Configs
    const tableConfig = dealsTableConfig(handleMissionNavigation, filterDealList, userData);

    return (
        <>
            <Toast/>
            <DealsDataSection
                data={dealsDataTable}
                tableConfig={tableConfig}
                tableLoading={loadingTable}
                handleButtonClick={() => setNewDealPopupView(true)}
                paginationMetadata={paginationMetadata}
                onTablePageChange={fetchDealsData}
            />
            <Popup
                view={newDealPopupView}
                setView={setNewDealPopupView}
                width={'1150px'}
                yOverflow='overflow-y-scroll'
                xOverflow=''
            >
                <NewDealPopup
                    setView={setNewDealPopupView}
                    userData={userData}
                />
            </Popup>
        </>
    );
}

export default DealsPage;
